export function formatErrorMessage(error: unknown): string {
  if (!error) return 'Unknown error occurred';

  // Case 1: already a string
  if (typeof error === 'string') {
    try {
      const parsed = JSON.parse(error);
      if (parsed && typeof parsed === 'object') {
        if ('error' in parsed) return parsed.error;
        if ('message' in parsed) return parsed.message;
      }
    } catch {
      // Not JSON — return raw string
      return error;
    }
  }

  // Case 2: Error object
  if (error instanceof Error) return error.message;

  // Case 3: direct object with keys
  if (typeof error === 'object' && error !== null) {
    if ('error' in error && typeof (error as any).error === 'string') {
      return (error as any).error;
    }
    if ('message' in error && typeof (error as any).message === 'string') {
      return (error as any).message;
    }
  }

  return 'Unexpected error occurred';
}